import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CalendarService } from '../calendar.service';
import { PatientsService } from '../patients.service';
import { Patient } from '../patients/patient';
import { PrintService } from '../print.service';

@Component({
    selector: 'app-printcalendar',
    templateUrl: './printcalendar.component.html',
    styleUrls: ['./printcalendar.component.scss'],
    standalone: false
})
export class PrintcalendarComponent implements OnInit {
  altHeader:SafeHtml;
  showHeader = false
  code;
  Direction;
  pregID;
  loaded =false;
  now;
  Pat;
  OB = [ '1st', 'NT', 'Early', '2nd/3rd','Weight Assessment', 'Late', 'Specialized' ,'Fetal Echo'];

  constructor(public cf:CalendarService,public ps:PatientsService,public http:HttpClient,private route: ActivatedRoute, public print:PrintService, public translate: TranslateService, private sanitizer: DomSanitizer) { 
    this.now = new Date();
  }

  ngOnInit() {
    this.translate.use('he-IL');
    this.Direction='rtl';
    let code = this.route.snapshot.params['code'];
    this.pregID = this.route.snapshot.params['pregID'];
    this.cf.pregID = this.route.snapshot.params['pregID'];
    if(this.route.snapshot.params.code){
      this.loadData(code)
    }

    this.cf.getCalendarData();
    this.cf.claloaded$.subscribe(() =>{
      this.loaded = true;
      if(this.cf.env['htmlheader']){
        this.altHeader=this.sanitizer.bypassSecurityTrustHtml(this.cf.env['htmlheader']);
      }   
    })
    

  }

  loadData(code){
    this.code = code;
    this.http.post('/api/newExams/resurection', {code:code}).subscribe((data) => {
      this.cf.getCalendarData();
      
    })
  }

}
